// extracted by mini-css-extract-plugin
export var youtubeactivated = "YouTubeLite-module--youtubeactivated--bfbc1";
export var youtubeiframe = "YouTubeLite-module--youtubeiframe--36eac";
export var youtubeplayer = "YouTubeLite-module--youtubeplayer--53960";
export var youtubewrapper = "YouTubeLite-module--youtubewrapper--9f0a2";